import type { SentryOptions } from "../../sentry-facade";
import type { AxiosError } from "axios";

import { isObject } from "../../../types/validation";

function getAdditionalDataFromError(
  error: Error,
  additional_data: Record<string, any> = {}
): {} {
  if ("additional_data" in error && isObject(error.additional_data)) {
    additional_data = {
      ...additional_data,
      ...error.additional_data
    };
  }

  if (error.cause instanceof Error) {
    return getAdditionalDataFromError(error.cause, additional_data);
  }

  return additional_data;
}

/**
 * Merges error's additional_data recursively into the provided SentryOptions
 *
 * @param error Error's cause are parsed recursively and any additional data are extracted
 * @param options A SentryOptions object where the additional data will be merged in.
 */
export const mergeAdditionalData = (
  error: Error | AxiosError,
  options: SentryOptions
): void => {
  const additional_data = getAdditionalDataFromError(
    error,
    options.extra?.additional_data
  );

  if (JSON.stringify(additional_data) !== "{}") {
    options.extra = {
      ...options.extra,
      additional_data
    };
  }
};
